import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next"; // <-- Importar useTranslation

const StyledSkipLink = styled("a")(({ theme }) => ({
  position: "absolute",
  top: "-40px", // Oculto por defecto
  left: "0",
  background: theme.palette.secondary.main,
  // color: '#fff', // <-- Antes
  color: theme.palette.secondary.contrastText || theme.palette.common.white, // <-- Usar color de contraste del tema o blanco como fallback
  padding: "8px 12px", // <-- Un poco más de padding horizontal
  zIndex: 9999, // Asegura que esté por encima de otros elementos
  transition: "top 0.2s ease-in-out", // <-- Transición suave
  "&:focus": {
    top: "10px", // <-- Mostrarlo con un pequeño margen superior
    left: "10px", // <-- Y un pequeño margen izquierdo
    outline: `2px solid ${theme.palette.primary.main}`, // <-- Añadir un outline claro para el foco
    outlineOffset: "2px",
  },
  fontWeight: "bold",
  fontSize: "0.9rem", // <-- Tamaño ligeramente ajustado
  borderRadius: "4px", // <-- Bordes redondeados simples
  textDecoration: "none", // <-- Quitar subrayado
}));

/**
 * Componente de accesibilidad que permite saltar al contenido principal.
 * Se vuelve visible solo cuando recibe el foco (por teclado).
 */
const SkipLink = ({ targetId = "main-content" }) => {
  const { t } = useTranslation(); // <-- Obtener la función de traducción

  // Usar la traducción para el texto, con fallback
  const text = t("common.skipToContent", "Saltar al contenido principal");

  return <StyledSkipLink href={`#${targetId}`}>{text}</StyledSkipLink>;
};

SkipLink.propTypes = {
  targetId: PropTypes.string,
  // text: PropTypes.string, // Ya no se necesita como prop si usamos i18n
};

export default SkipLink;
